import { Route } from 'react-router-dom';
import ProtectedRoute from '../auth/Utils/ProtectedRoute';
import ContactListPage from './pages/ContactListPage';
import ContactDetailsPage from './pages/ContactDetailsPage';
import CreateContactPage from './pages/CreateContactPage';
import EditContactPage from './pages/EditContactPage';

export const ContactsRoutes = () => (
  <Route path="contacts">
    <Route
      index
      element={
        <ProtectedRoute requiredScope="contact:read">
          <ContactListPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="create"
      element={
        <ProtectedRoute requiredScope="contact:create">
          <CreateContactPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":contactId"
      element={
        <ProtectedRoute requiredScope="contact:read">
          <ContactDetailsPage />
        </ProtectedRoute>
      }
    />
    <Route
      path=":contactId/edit"
      element={
        <ProtectedRoute requiredScope="contact:update">
          <EditContactPage />
        </ProtectedRoute>
      }
    />
  </Route>
);
